import { useState } from 'react'
import { Link } from 'react-router-dom'
import { authApi } from '../../api/auth'
import Header from '../../components/layout/Header'
import Footer from '../../components/layout/Footer'
import Button from '../../components/common/Button'
import Input from '../../components/common/Input'
import './Auth.css'

const ForgotPassword = () => {
  const [email, setEmail] = useState('')
  const [error, setError] = useState('')
  const [success, setSuccess] = useState(false)
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')
    setLoading(true)

    try {
      const result = await authApi.forgotPassword(email)
      if (result.success) {
        setSuccess(true)
      } else {
        setError(result.message || 'حدث خطأ')
      }
    } catch (err) {
      setError('حدث خطأ أثناء إرسال الطلب')
    } finally {
      setLoading(false)
    }
  }

  if (success) {
    return (
      <div className="auth-page">
        <Header />
        <main className="auth-main">
          <div className="auth-container">
            <div className="auth-card">
              <h1 className="auth-title">تم إرسال البريد</h1>
              <p className="auth-subtitle">
                تم إرسال رابط إعادة تعيين كلمة المرور إلى بريدك الإلكتروني
              </p>
              <Link to="/login">
                <Button variant="primary" fullWidth>
                  العودة لتسجيل الدخول
                </Button>
              </Link>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    )
  }

  return (
    <div className="auth-page">
      <Header />
      <main className="auth-main">
        <div className="auth-container">
          <div className="auth-card">
            <h1 className="auth-title">نسيت كلمة المرور</h1>
            <p className="auth-subtitle">
              أدخل بريدك الإلكتروني لإعادة تعيين كلمة المرور
            </p>

            <form onSubmit={handleSubmit} className="auth-form">
              <Input
                label="البريد الإلكتروني"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                fullWidth
              />

              {error && <div className="auth-error">{error}</div>}

              <Button
                type="submit"
                variant="primary"
                size="lg"
                fullWidth
                loading={loading}
                disabled={loading}
              >
                إرسال
              </Button>

              <div className="auth-footer">
                <Link to="/login" className="auth-link-primary">
                  العودة لتسجيل الدخول
                </Link>
              </div>
            </form>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  )
}

export default ForgotPassword

